/**
 * @module FE-CU31_各種設定画面
 */
import Header from '@/components/header/Header.vue';
import MobileFooter from '@/components/footer/MobileFooter.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';
import ExternalUrl from '../../api/externalLinks/externalUrls';

const PAGE_ID = 'FE-CU31';

export default {
  name: 'VariousSettings',
  components: {
    Header,
    MobileFooter,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.各種設定'), //"各種設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU31各種設定画面.C0001'),
      //"対象地区/カメラ/ユーザー情報/ログイン方法(*1)の設定項目を選択し、各画面から設定を行うことができます。\n*1:ログイン方法はスマートフォンアプリのみ設定を行うことができます。",
      buttonList: [
        {
          id: 1,
          title: '$vuetify.FECU31各種設定画面.アカウント管理_対象地区', // "アカウント管理(対象地区)",
          text: '$vuetify.FECU31各種設定画面.対象地区に紐づくサブユーザーの登録削除', // "対象地区に紐づくサブユーザの登録・削除",
          image: require('../../assets/images/icon/display-district.png'),
          alt: '$vuetify.FECU31各種設定画面.対象地区', //"対象地区",
          url: '/displayDistrictAccountManagement',
          display: false,
        },
        {
          id: 2,
          title: '$vuetify.FECU31各種設定画面.アカウント管理_カメラ', // "アカウント管理(カメラ)",
          text: '$vuetify.FECU31各種設定画面.カメラに紐づくサブユーザーの登録削除', //"カメラに紐づくサブユーザの登録削除",
          image: require('../../assets/images/icon/camera00.png'),
          alt: '$vuetify.FECU31各種設定画面.カメラ', //"カメラ",
          url: '/cameraAccountManagement',
          display: false,
        },
        {
          id: 3,
          title: '$vuetify.FECU31各種設定画面.アカウント管理_ユーザー情報', // "アカウント管理(ユーザー情報)",
          text: '$vuetify.FECU31各種設定画面.ユーザー情報の登録削除', // "ユーザー情報の登録・削除",
          image: require('../../assets/images/icon/user-info.png'),
          alt: 'ユーザー情報',
          url: '/userInfoAccountManagement',
          display: false,
        },
        {
          id: 4,
          title: '$vuetify.FECU31各種設定画面.ログイン方法設定', // "ログイン方法設定",
          text: '$vuetify.FECU31各種設定画面.ログイン方法の設定', //"ログイン方法の設定",
          image: require('../../assets/images/icon/login-way-setting.png'),
          alt: '$vuetify.FECU31各種設定画面.ログイン', //"ログイン",
          url: '/loginSettings',
          display: true,
        },
      ],
      buttonListPC: [],
      callbackResult: {
        externalApp: {
          errorCode: '',
        },
      },
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.各種設定'), //"各種設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU31各種設定画面.C0001'),
        //"対象地区/カメラ/ユーザー情報/ログイン方法(*1)の設定項目を選択し、各画面から設定を行うことができます。\n*1:ログイン方法はスマートフォンアプリのみ設定を行うことができます。",
        buttonList: [
          {
            id: 1,
            title: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.アカウント管理_対象地区'), // "アカウント管理(対象地区)",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU31各種設定画面.対象地区に紐づくサブユーザーの登録削除'
            ), // "対象地区に紐づくサブユーザの登録・削除",
            image: require('../../assets/images/icon/display-district.png'),
            alt: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.対象地区'), //"対象地区",
            url: '/displayDistrictAccountManagement',
            display: this.buttonList[0].display,
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.アカウント管理_カメラ'), // "アカウント管理(カメラ)",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU31各種設定画面.カメラに紐づくサブユーザーの登録削除'
            ), //"カメラに紐づくサブユーザの登録削除",
            image: require('../../assets/images/icon/camera00.png'),
            alt: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.カメラ'), //"カメラ",
            url: '/cameraAccountManagement',
            display: this.buttonList[1].display,
          },
          {
            id: 3,
            title: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.アカウント管理_ユーザー情報'), // "アカウント管理(ユーザー情報)",
            text: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.ユーザー情報の登録削除'), // "ユーザー情報の登録・削除",
            image: require('../../assets/images/icon/user-info.png'),
            alt: 'ユーザー情報',
            url: '/userInfoAccountManagement',
            display: this.buttonList[2].display,
          },
          {
            id: 4,
            title: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.ログイン方法設定'), // "ログイン方法設定",
            text: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.ログイン方法の設定'), //"ログイン方法の設定",
            image: require('../../assets/images/icon/login-way-setting.png'),
            alt: vm.$vuetify.lang.t('$vuetify.FECU31各種設定画面.ログイン'), //"ログイン",
            url: '/loginSettings',
            display: this.buttonList[3].display,
          },
        ],
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * ボタン押下時処理
     * @param {*} url URLパラメータ
     */
    async push(url) {
      if (this.$isMobileApp) {
        if (url === '/loginSettings') {
          // ログイン設定画面への遷移の時は,本画面からの遷移であることをクエリで渡す
          this.$router.push({
            path: url,
            query: { from: 'variousSettings' },
          });
        } else {
          let word = '';
          let accountManagementUrl = '';
          if (url === '/displayDistrictAccountManagement') {
            word = '$vuetify.メッセージ一覧.FECU31各種設定画面.C0002';
            accountManagementUrl = ExternalUrl.alsockWeAppDisplayDistrictAccountManagement;
          } else if (url === '/cameraAccountManagement') {
            word = '$vuetify.メッセージ一覧.FECU31各種設定画面.C0003';
            accountManagementUrl = ExternalUrl.alsockWebAppCameraAccountManagement;
          } else if (url === '/userInfoAccountManagement') {
            word = '$vuetify.メッセージ一覧.FECU31各種設定画面.C0004';
            accountManagementUrl = ExternalUrl.alsockWebAppUserInfoAccountManagement;
          }
          const result = await this.$agreementDialog(
            '$vuetify.agreementDialog.確認',
            word,
            '$vuetify.agreementDialog.いいえボタン',
            '$vuetify.agreementDialog.はいボタン'
          );
          if (result) {
            // ログイン引継トークン発行
            let param = '/api/common/issueTakeoverToken';
            let queries = {
              token: sessionStorage.getItem('token'),
              terminalInfo: localStorage.getItem('terminalInfo')
                ? localStorage.getItem('terminalInfo')
                : '',
            };
            let method = 'post';
            await this.APP_CU9912(param, queries, method);

            NativeApi.openExternalBrowserWithToken(accountManagementUrl);
            //ログアウト処理
            await this.$_APP_CU0202();
          } else {
            // only close Dialog
          }
        }
      } else {
        // ブラウザの場合
        this.$router.push({
          path: url,
          //query: { hoge_token: data }
        });
      }
    },
    /**
     * アカウント管理(表示地区)画面 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU3201: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: [
            //       {
            //         displayDistrictNickname: "",
            //         displayDistrictUserType: 1,
            //         userManagementAuthority: true,
            //         emergencyContactAuthority: true,
            //         customerNumber: "",
            //         securityDestinationName: "1",
            //         districtSplitNumber: "",
            //         districtSplitName: "",
            //       },
            //       {
            //         displayDistrictNickname: "",
            //         displayDistrictUserType: 1,
            //         userManagementAuthority: true,
            //         emergencyContactAuthority: true,
            //         customerNumber: "",
            //         securityDestinationName: "1",
            //         districtSplitNumber: "",
            //         districtSplitName: "",
            //       },
            //     ],
            //   },
            // };

            if (apiData.contentsInfo.displayDistrictInfo.length >= 1) {
              // アカウント管理(表示地区)ボタンを表示
              this.buttonList[0].display = true;
              this.buttonListPC.push({
                id: 1,
                title: '$vuetify.FECU31各種設定画面.アカウント管理_対象地区', // "アカウント管理(対象地区)",
                text: '$vuetify.FECU31各種設定画面.対象地区に紐づくサブユーザーの登録削除', // "対象地区に紐づくサブユーザの登録・削除",
                image: require('../../assets/images/icon/display-district.png'),
                alt: '$vuetify.FECU31各種設定画面.対象地区', //"対象地区",
                url: '/displayDistrictAccountManagement',
                display: true,
              });
            }
          },
          (error /* eslint-disable-line */) => {
            this.buttonList[0].display = false;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU3101>>>", apiData);
      return apiData;
    },
    /**
     * アカウント管理(カメラ)画面 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU3301: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     cameraListInfo: [
            //       {
            //         cameraNickname: "",
            //         cameraUserType: 0,
            //         userManagementAuthority: true,
            //         emergencyContactAuthority: true,
            //         customerNumber: "",
            //         securityDestinationName: "",
            //         deviceID: "",
            //         districtSplitNumber: "",
            //         districtSplitName: "",
            //         usagePlanId: "",
            //         deletableFlag: true,
            //         modified: "",
            //       },
            //       {
            //         cameraNickname: "",
            //         cameraUserType: 0,
            //         userManagementAuthority: true,
            //         emergencyContactAuthority: true,
            //         customerNumber: "",
            //         securityDestinationName: "",
            //         deviceID: "",
            //         districtSplitNumber: "",
            //         districtSplitName: "",
            //         usagePlanId: "",
            //         deletableFlag: true,
            //         modified: "",
            //       },
            //     ],
            //   },
            // };

            if (apiData.contentsInfo.cameraListInfo.length >= 1) {
              // アカウント管理(カメラ)ボタンを表示
              this.buttonList[1].display = true;
              this.buttonListPC.push({
                id: 2,
                title: '$vuetify.FECU31各種設定画面.アカウント管理_カメラ', // "アカウント管理(カメラ)",
                text: '$vuetify.FECU31各種設定画面.カメラに紐づくサブユーザーの登録削除', //"カメラに紐づくサブユーザの登録削除",
                image: require('../../assets/images/icon/camera00.png'),
                alt: '$vuetify.FECU31各種設定画面.カメラ', //"カメラ",
                url: '/cameraAccountManagement',
                display: true,
              });
            }
          },
          (error /* eslint-disable-line */) => {
            this.buttonList[1].display = false;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU3201>>>", apiData);
      return apiData;
    },
    /**
     * アカウント管理(ユーザー情報)画面 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU3401: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // アカウント管理(ユーザー情報)ボタンを表示
            this.buttonList[2].display = true;
            this.buttonListPC.push({
              id: 3,
              title: '$vuetify.FECU31各種設定画面.アカウント管理_ユーザー情報', // "アカウント管理(ユーザー情報)",
              text: '$vuetify.FECU31各種設定画面.ユーザー情報の登録削除', // "ユーザー情報の登録・削除",
              image: require('../../assets/images/icon/user-info.png'),
              alt: '$vuetify.FECU31各種設定画面.ユーザー情報', // "ユーザー情報",
              url: '/userInfoAccountManagement',
              display: true,
            });
          },
          (error /* eslint-disable-line */) => {
            this.buttonList[2].display = false;
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU3301>>>", apiData);
      return apiData;
    },
    /**
     * ログイン引継トークン発行API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU9912: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     takeoverToken: 'string'
            //   }
            // }
            sessionStorage.setItem('takeoverToken', apiData.contentsInfo.takeoverToken ?? '');
          },
          (error /* eslint-disable-line */) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
  },
  watch: {
    'callbackResult.externalApp'(newVal, oldVal) {
      if (oldVal !== '') return;

      if (NativeCallback.codeInclude(newVal.errorCode, '12-E0001')) {
        // ブラウザ表示失敗時の処理
      }
    },
    deep: true,
  },
  beforeMount() {
    // IF12_外部ブラウザの起動結果を受け取る
    window.onOpenExternalAppFinished = (errorCode) => {
      this.callbackResult.externalApp = NativeCallback.onOpenExternalAppFinished(errorCode);
    };
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    this.isShowPage = true;

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
    };

    let method = 'post';

    // APP_CU3201
    let param = '/api/displayDistrictAccountManagement/init';
    // let param = "post";
    await this.APP_CU3201(param, queries, method);

    // APP_CU3301
    param = '/api/cameraAccountManagement/init';
    // param = "post";
    await this.APP_CU3301(param, queries, method);

    // APP_CU3401
    param = '/api/userInfoAccountManagement/init';
    // param = "post";
    await this.APP_CU3401(param, queries, method);
  },
};
